import { Component, Input, Output } from 'angular-ts-decorators';

import { IProductFilter, IProductFilterGroup } from '../models';

import template from './product-filter-group.component.html';

interface IOnFilterChangeFnArgs {
  filterId: string;
  filterGroup: IProductFilterGroup;
}

type IOnFilterChangeFn = (args: IOnFilterChangeFnArgs) => void;

@Component({
  selector: 'productFilterGroup',
  template,
})
export class ProductFilterGroupComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public filterGroup: IProductFilterGroup;

  @Output() public onFilterChange: IOnFilterChangeFn;

  public showFilters = false;

  public overlayClicked() {
    this.showFilters = false;
  }

  public toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  public filterChanged(filter: IProductFilter) {
    this.showFilters = false;
    if (this.onFilterChange) {
      this.onFilterChange({ filterId: filter.id, filterGroup: this.filterGroup });
    }
  }
}
